import { InfoIcon } from '@rsos/assets/icons';
import { Content, Wrapper } from './Banner.styles';

export const Banner = ({ text }: { text: string }) => {
  return (
    <Wrapper>
      <Content>
        <InfoIcon width={15} />
        <p> {text} </p>
      </Content>
    </Wrapper>
  );
};
